import { combineReducers } from "@reduxjs/toolkit";
import userSlice from "./userSlice";
import bartenderSlice from "./bartenderSlice";
import formSlice from "./formSlice";
import businessSlice from "./businessSlice";
import billingInfoSlice from "./billingInfoSlice";
import paymentSlice from './paymentFormSlice';

const rootReducer = combineReducers({
  user: userSlice,
  bartender: bartenderSlice,
  form: formSlice,
  business: businessSlice,
  billing: billingInfoSlice,
  paymentForm: paymentSlice
});

export default rootReducer;
export type RootState = ReturnType<typeof rootReducer>;
